module.exports = __webpack_public_path__ + "static/media/Entrails.ff7ea5ec.png";